import type { GraphQLFormattedError } from "graphql";

const hasExtensions = <T>(
  error: unknown
): error is T & { extensions: GraphQLFormattedError["extensions"] } => {
  return !!(error as GraphQLFormattedError).extensions;
};

const getErrorCode = (error: unknown): string | undefined => {
  if (!hasExtensions(error)) return;

  return error.extensions?.code;
};

export const getErrorCodes = (
  errors: readonly GraphQLFormattedError[] | GraphQLFormattedError[]
): string[] => {
  return errors
    .map((error) => getErrorCode(error))
    .filter((x): x is string => !!x);
};

export const containsSomeOfErrors = (
  codes: string[],
  errors: readonly GraphQLFormattedError[] | GraphQLFormattedError[]
): boolean => {
  const errorCodes = getErrorCodes(errors);

  return errorCodes.some((code) => codes.includes(code));
};
